import React, { FC } from 'react';
import styled from 'styled-components';
import { ThirdpartyIntegrationType } from 'api/integrations';
import { ReactComponent as JiraLogo } from './Jira.svg';
import { ReactComponent as SalesforceLogo } from './Salesforce.svg';
import { ReactComponent as SlackLogo } from './Slack.svg';

interface Props {
  type: ThirdpartyIntegrationType;
}

const LogoWrapper = styled.div`
  margin-left: var(--spacing-03);
`;

export const MessageOrigin: FC<Props> = ({ type }) => {
  switch (type) {
    case ThirdpartyIntegrationType.Slack:
      return (
        <LogoWrapper>
          <SlackLogo />
        </LogoWrapper>
      );
    case ThirdpartyIntegrationType.Jira:
      return (
        <LogoWrapper>
          <JiraLogo />
        </LogoWrapper>
      );
    case ThirdpartyIntegrationType.Salesforce:
      return (
        <LogoWrapper>
          <SalesforceLogo />
        </LogoWrapper>
      );

    default:
      return null;
  }
};
